import * as t from "io-ts"

export const TAirportContact = t.interface({
  airport: t.string,
  oohContact: t.string
})

export const TAirportContacts = t.array(TAirportContact)

export type AirportContact = t.TypeOf<typeof TAirportContact>
export type AirportContacts = t.TypeOf<typeof TAirportContacts>
